import { getSuper, addSuper, putSuper, delSuper, getSuperTree } from '@/api/super'
// import { getToken } from '@/utils/auth'
const state = {
}
const mutations = {

}

const actions = {
	// 获取超市列表
	getSuper ({ }, data) {
		return new Promise((resolve, reject) => {
			getSuper(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 新增超市
	addSuper ({ }, data) {
		return new Promise((resolve, reject) => {
			addSuper(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 修改超市
	putSuper ({ }, data) {
		return new Promise((resolve, reject) => {
			putSuper(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 删除超市
	delSuper ({ }, data) {
		return new Promise((resolve, reject) => {
			delSuper(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	},
	// 获取食堂树
	getSuperTree ({ }, data) {
		return new Promise((resolve, reject) => {
			getSuperTree(data).then(res => {
				resolve(res)
			}).catch(error => {
				reject(error)
			})
		})
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}
